// extracted by mini-css-extract-plugin
module.exports = {"bannerMessage":"mlgSJ3"};